import { AbstractQuery } from 'src/models/query';

const MAIL_CONTENT_QUERY_NAME = 'IFS_Desktop_Query_Queries_Mail_GetTheContentForTheMailQuery';

export class MailQuery extends AbstractQuery {
	override name = MAIL_CONTENT_QUERY_NAME;
	override sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class GetTheOriginalSourceForTheMailQuery extends AbstractQuery {
	override name = MAIL_CONTENT_QUERY_NAME;
	override sort = [];
	override subscribeForUpdates = false;

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
		this.parameters.push({ detailVariant: 'originalSource' });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetTheUnprocessedContentForTheMailQuery extends AbstractQuery {
	override name = MAIL_CONTENT_QUERY_NAME;
	override sort = [];
	override subscribeForUpdates = false;

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
		this.parameters.push({ detailVariant: 'unprocessedContent' });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetTheAttachmentsForTheMailQuery extends AbstractQuery {
	override name = 'IFS_Desktop_Query_Queries_Mail_GetTheAttachmentsForTheMailQuery';
	override sort = [];

	constructor(aggregateId: string, storageKeys: string[]) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
		this.parameters.push({ storageKeys: storageKeys });
	}
}

export class GetTheAttachmentViewerContentForTheMailQuery extends AbstractQuery {
	override name = 'IFS_Desktop_Query_Queries_Mail_GetTheAttachmentViewerContentForTheMailQuery';
	override sort = [];

	constructor(aggregateId: string, storageKey: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
		this.parameters.push({ storageKey: storageKey });
	}
}

export class GetTheMailAddressSuggestionsQuery extends AbstractQuery {
	override name = 'IFS_Desktop_Query_Queries_Mail_GetTheMailAddressSuggestionsQuery';
	override sort = [];
	override subscribeForUpdates = false;
	constructor(searchTerm: string) {
		super();
		this.parameters.push({ searchTerm: searchTerm });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}

	override uniqueQueryIdentifier(): string {
		return this.createStableIdentifier();
	}
}

export class GetReceiverGroupsForAuthenticatedUserQuery extends AbstractQuery {
	override name = 'IFS_Mail_Query_Queries_GetReceiverGroupsForAuthenticatedUserQuery';
	override sort = [];
	override subscribeForUpdates = false;

	constructor() {
		super();
		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetReceiverGroupMembersForAuthenticatedUserQuery extends AbstractQuery {
	override name = 'IFS_Mail_Query_Queries_GetReceiverGroupMembersForAuthenticatedUserQuery';
	override sort = [];
	override subscribeForUpdates = false;

	constructor(groupId: number) {
		super();
		this.parameters.push({ groupId: groupId });
		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetTheMailAccountsAndSignaturesAndDraftsAndTemplatesForTheAuthenticatedUserQuery extends AbstractQuery {
	override name =
		'IFS_Desktop_Query_Queries_Mail_GetTheMailAccountsAndSignaturesAndDraftsAndTemplatesForTheAuthenticatedUserQuery';
	override sort = [];
}

export class GetTheMailTemplateOrDraftForTheAuthenticatedUserQuery extends AbstractQuery {
	override name = 'IFS_Desktop_Query_Queries_Mail_GetTheMailTemplateOrDraftForTheAuthenticatedUserQuery';
	override sort = [];

	constructor(draftOrTemplateId: string) {
		super();
		this.parameters.push({ draftOrTemplateId: draftOrTemplateId });
	}
}
